import React from 'react';
import {Link} from 'react-router-dom'

const e = React.createElement;


function ModalWrapper(props) {
  React.Component.constructor.call(this);

  this.setWrapperRef = this.setWrapperRef.bind(this);
  this.handleClickOutside = this.handleClickOutside.bind(this);
}
ModalWrapper.prototype = Object.create(React.Component.prototype);

ModalWrapper.prototype.componentDidMount = function() {
  document.addEventListener('mousedown', this.handleClickOutside);
  // document.addEventListener('keydown', this.handleClickOutside);
}
ModalWrapper.prototype.componentWillUnmount = function() {
  document.removeEventListener('mousedown', this.handleClickOutside);
  // document.removeEventListener('keydown', this.handleClickOutside);
}

ModalWrapper.prototype.setWrapperRef = function(node) {
  this.wrapperRef = node;
}

ModalWrapper.prototype.handleClickOutside = function(e) {
  if(this.wrapperRef && !this.wrapperRef.contains(e.target) && e.target.id !== "alert") {
    // if ((!e.key && this.wrapperRef && !this.wrapperRef.contains(e.target) && e.target.id !== "alert") || (e.key && e.key === "Escape")) {
    this.props.switchState();
  }
}

ModalWrapper.prototype.render = function() {
  var classNm = (typeof this.props.mainClass !== "undefined") ? "main "+this.props.mainClass : "main";
  var classNmWrapper = (typeof this.props.wrapperClass !== "undefined") ? "modal-wrapper "+this.props.wrapperClass : "modal-wrapper";
  return e('div', null, [
    e('div', {key:"1", className:classNmWrapper}, [
      e('div', {key:"11", className:"modal-content"}, [
        e('div', {key:"21", className:"modal", ref:this.setWrapperRef}, [
          this.props.ribbon && e('div', {key:"r1", className:"ribbon"}),
          this.props.header && !this.props.headerimg && e('div', {key:"h1", className:"modal-header"}, e('h1', null, this.props.header)),
          this.props.header && this.props.headerimg && e('div', {key:"himg1", className:"modal-header"}, e('img', {src:this.props.headerimg, alt:this.props.header})),
          e('div', {key:"31", className:classNm}, this.props.children),
          this.props.ribbon && e('div', {key:"r2", className:"ribbon"}),
        ]),
      ]),
    ]),
    e('div', {key:"2", className:"modal-overlay"}),
  ]);
}


export default ModalWrapper



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Modal_Wrapper.js
// module id = 218
// module chunks = 0